export default {
  token: state => state.user.api_token,
  role:  state => state.user.role,
  userName: state => state.user.name,
  user: state => state.user
};
